export enum FILE_TYPE {
	'videos' = 5,
	'audios' = 6,
	'documents' = 7,
	'interactive' = 8, // Interactivo
	'readingPlan' = 9, // Plan lector
	'presentationsPlenaries' = 10, // Presentaciones/Plenarias
	'guides' = 11, // Guías
	'placesInterest' = 13, // Sitios en interés
	'softwareFree' = 14, // Software gratuito
	'educationalServices' = 15, // Servicios pedagógicos
	'help' = 16,
	'textBooks' = 18, // Libros de texto
	'digitalTextBooks' = 19, // Libros de texto digital
	'presentations' = 20, // Presentaciones
	'dosage' = 21, // Dosificaciones
	'cuadernillos' = 22,
	'baldor' = 23,
	'nuevaEscuelaMexicana' = 24,
	'solucionarios' = 25,
	'presentacionesWebinar' = 26,
	'novedades' = 30,
	'posters' = 31,
}

export const FILE_TYPE_AUDIO: number[] = [FILE_TYPE.audios, FILE_TYPE.presentations];
export const FILE_TYPE_VIDEO: number[] = [FILE_TYPE.videos];
export const FILE_TYPE_LINK: number[] = [
	FILE_TYPE.interactive,
	FILE_TYPE.digitalTextBooks,
];
export const FILE_TYPE_DOWNLOAD: number[] = [FILE_TYPE.audios, FILE_TYPE.videos];
export const FILE_TYPE_PDF = [
	FILE_TYPE.documents,
	FILE_TYPE.guides,
	FILE_TYPE.help,
	FILE_TYPE.textBooks,
	FILE_TYPE.dosage,
	FILE_TYPE.solucionarios,
	FILE_TYPE.presentacionesWebinar,
	FILE_TYPE.cuadernillos,
	FILE_TYPE.baldor,
	FILE_TYPE.nuevaEscuelaMexicana,
	FILE_TYPE.novedades,
	FILE_TYPE.posters,
];
